// Class: openfl.display._internal._CanvasGraphics.Scale9GridBounds

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../../hxClasses_stub").default;
var $hxEnums = require("./../../../../hxEnums_stub").default;

// Constructor

var Scale9GridBounds = function() {
	this.unscaledMaxY = null;
	this.unscaledMaxX = null;
	this.unscaledMinY = null;
	this.unscaledMinX = null;
	this.scale9MaxY = null;
	this.scale9MaxX = null;
	this.scale9MinY = null;
	this.scale9MinX = null;
}

// Meta

Scale9GridBounds.__name__ = "openfl.display._internal._CanvasGraphics.Scale9GridBounds";
Scale9GridBounds.__isInterface__ = false;
Scale9GridBounds.prototype = {
	getScaleX: function() {
		if(this.scale9MaxX == null || this.unscaledMaxX == null) {
			return 1.0;
		}
		var unscaledWidth = this.unscaledMaxX - this.unscaledMinX;
		if(unscaledWidth == 0.0) {
			return 1.0;
		}
		return (this.scale9MaxX - this.scale9MinX) / unscaledWidth;
	},
	getScaleY: function() {
		if(this.scale9MaxY == null || this.unscaledMaxY == null) {
			return 1.0;
		}
		var unscaledHeight = this.unscaledMaxY - this.unscaledMinY;
		if(unscaledHeight == 0.0) {
			return 1.0;
		}
		return (this.scale9MaxY - this.scale9MinY) / unscaledHeight;
	},
	clear: function() {
		this.unscaledMinX = null;
		this.unscaledMaxX = null;
		this.unscaledMinY = null;
		this.unscaledMaxY = null;
		this.scale9MinX = null;
		this.scale9MaxX = null;
		this.scale9MinY = null;
		this.scale9MaxY = null;
	},
	applyUnscaledX: function(value) {
		if(this.unscaledMinX == null || this.unscaledMinX > value) {
			this.unscaledMinX = value;
		}
		if(this.unscaledMaxX == null || this.unscaledMaxX < value) {
			this.unscaledMaxX = value;
		}
	},
	applyUnscaledY: function(value) {
		if(this.unscaledMinY == null || this.unscaledMinY > value) {
			this.unscaledMinY = value;
		}
		if(this.unscaledMaxY == null || this.unscaledMaxY < value) {
			this.unscaledMaxY = value;
		}
	},
	applyScaledX: function(value) {
		if(this.scale9MinX == null || this.scale9MinX > value) {
			this.scale9MinX = value;
		}
		if(this.scale9MaxX == null || this.scale9MaxX < value) {
			this.scale9MaxX = value;
		}
	},
	applyScaledY: function(value) {
		if(this.scale9MinY == null || this.scale9MinY > value) {
			this.scale9MinY = value;
		}
		if(this.scale9MaxY == null || this.scale9MaxY < value) {
			this.scale9MaxY = value;
		}
	}
};
Scale9GridBounds.prototype.__class__ = Scale9GridBounds.prototype.constructor = $hxClasses["openfl.display._internal._CanvasGraphics.Scale9GridBounds"] = Scale9GridBounds;

// Init



// Statics




// Export

exports.default = Scale9GridBounds;